import { Component } from '@angular/core';

@Component({
  selector: 'app-usp',
  templateUrl: './usp.component.html',
  styleUrls: ['./usp.component.scss']
})

export class UspComponent {
  usps:any = [];
  constructor() {
    this.usps = [{
      header: 'Understand Your Inventory Inside Out',
      sub_header: 'Take your inventory management to the next level - look beyond tracking and understand it inside out.',
      button: 'Track Now',
      img: 'assets/img/inventory.svg',
      alt: 'Tracking inventory using digital means'
    }, {
      header: 'QR\'s the Key, Know Your Resources Accurately',
      sub_header: 'Stay ahead of the curve with our cutting-edge QR tech and empower your business with accurate resource management.',
      button: 'Scan Now',
      img: 'assets/img/qr.svg',
      alt: 'Scanning QR code on packages'
    }, {
      header: 'Comprehensive Care, Patient 360 Everywhere',
      sub_header: 'A centralized ecosystem that brings together all of a patients\' health information in one place.',
      button: 'Experience Now',
      img: 'assets/img/360.svg',
      alt: 'Patient 360 for a comprehensive view of a patient'
    }, {
      header: 'Empower Your Management with Unlimited User Access',
      sub_header: 'Allows you to add as many users as you want, without any restriction or additional cost.',
      button: 'Expand Now',
      img: 'assets/img/user_access.svg',
      alt: 'All users of a hospitals connected together on one system'
    }, {
      header: 'Connect with Just a Click, No Installation Required',
      sub_header: 'No need to install anything, just connect and start using.',
      button: 'Start Using',
      img: 'assets/img/connect.svg',
      alt: 'Connect to your software anytime, anywhere'
    }, {
      header: 'Generate Prescriptions Within Seconds',
      sub_header: 'Experience a digital revolution - transform your Prescriptions to digital in seconds.',
      button: 'See How',
      img: 'assets/img/prescription.svg',
      alt: 'Writing a perscription online'
    }, {
      header: 'Simplify Claims for Better Care',
      sub_header: 'Enhancing patient care through simplified claims.',
      button: 'Claim It Easier',
      img: 'assets/img/claim.svg',
      alt: 'Have quick access to patient claims'
    }]
  }
}
